//Action Creators for Analyitcs Site
import axios from 'axios';
//import baseApi from '../apis/approvalsApi';


const avgsDataTest = {
    "approvalTimes180Days": [
        {
            "appName": "Agile",
            "totalAverageTimeToApprove": 2.5
        },
        {
            "appName": "HelpNow",
            "totalAverageTimeToApprove": 5.2
        },
        {
            "appName": "RCE",
            "totalAverageTimeToApprove": 1.2
        },
        {
            "appName": "Neputne MT",
            "totalAverageTimeToApprove": 4.2
        },
        {
            "appName": "Neptune PS",
            "totalAverageTimeToApprove": 2.2
        },
        {
            "appName": "SmartRecruiters",
            "totalAverageTimeToApprove": 1.0
        },
        {
            "appName": "Fieldglass",
            "totalAverageTimeToApprove": 1.0
        },
        {
            "appName": "Ivalua",
            "totalAverageTimeToApprove": 5.2
        },
        {
            "appName": "MES",
            "totalAverageTimeToApprove": 3.2
        },
        {
            "appName": "SAPQN",
            "totalAverageTimeToApprove": 5.2
        },
        {
            "appName": "SAM",
            "totalAverageTimeToApprove": 3.2
        },
        {
            "appName": "Trackwise",
            "totalAverageTimeToApprove": 6.2
        },
        {
            "appName": "IT Timesheet",
            "totalAverageTimeToApprove": 2.2
        },
        {
            "appName": "Coupa",
            "totalAverageTimeToApprove": 1.2
        },
        {
            "appName": "My HCM",
            "totalAverageTimeToApprove": 2.2
        },
        {
            "appName": "Concur",
            "totalAverageTimeToApprove": 4.2
        }
    ],
    "approvalTimes30Days": [
        {
            "appName": "Agile",
            "totalAverageTimeToApprove": 2.2
        },
        {
            "appName": "HelpNow",
            "totalAverageTimeToApprove": 5.0
        },
        {
            "appName": "RCE",
            "totalAverageTimeToApprove": 4.2
        },
        {
            "appName": "Neputne MT",
            "totalAverageTimeToApprove": 1.2
        },
        {
            "appName": "Neptune PS",
            "totalAverageTimeToApprove": 2.0
        },
        {
            "appName": "SmartRecruiters",
            "totalAverageTimeToApprove": 3.0
        },
        {
            "appName": "Fieldglass",
            "totalAverageTimeToApprove": 2.0
        },
        {
            "appName": "Ivalua",
            "totalAverageTimeToApprove": 3.2
        },
        {
            "appName": "MES",
            "totalAverageTimeToApprove": 1.2
        },
        {
            "appName": "SAPQN",
            "totalAverageTimeToApprove": 5.2
        },
        {
            "appName": "SAM",
            "totalAverageTimeToApprove": 1.2
        },
        {
            "appName": "Trackwise",
            "totalAverageTimeToApprove": 3.2
        },
        {
            "appName": "IT Timesheet",
            "totalAverageTimeToApprove": 1.2
        },
        {
            "appName": "Coupa",
            "totalAverageTimeToApprove": 4.2
        },
        {
            "appName": "My HCM",
            "totalAverageTimeToApprove": 2.2
        },
        {
            "appName": "Concur",
            "totalAverageTimeToApprove": 4.2
        }
    ],
    "approvalTimes1Day": [
        {
            "appName": "Agile",
            "totalAverageTimeToApprove": 1.5
        },
        {
            "appName": "HelpNow",
            "totalAverageTimeToApprove": 2.2
        },
        {
            "appName": "RCE",
            "totalAverageTimeToApprove": 3.2
        },
        {
            "appName": "Neputne MT",
            "totalAverageTimeToApprove": 4.2
        },
        {
            "appName": "Neptune PS",
            "totalAverageTimeToApprove": 2.2
        },
        {
            "appName": "SmartRecruiters",
            "totalAverageTimeToApprove": 1.0
        },
        {
            "appName": "Fieldglass",
            "totalAverageTimeToApprove": 4.0
        },
        {
            "appName": "Ivalua",
            "totalAverageTimeToApprove": 2.2
        },
        {
            "appName": "MES",
            "totalAverageTimeToApprove": 7.2
        },
        {
            "appName": "SAPQN",
            "totalAverageTimeToApprove": 2.2
        },
        {
            "appName": "SAM",
            "totalAverageTimeToApprove": 1.2
        },
        {
            "appName": "Trackwise",
            "totalAverageTimeToApprove": 6.2
        },
        {
            "appName": "IT Timesheet",
            "totalAverageTimeToApprove": 1.0
        },
        {
            "appName": "Coupa",
            "totalAverageTimeToApprove": 1.1
        },
        {
            "appName": "My HCM",
            "totalAverageTimeToApprove": 2.0
        },
        {
            "appName": "Concur",
            "totalAverageTimeToApprove": 2.1
        }
    ]
};

export const attaFilterSelected = (filter) => {
    //return an action
    return {
        type: 'ATTA_FILTER_SELECTED',
        payload: filter
    };
};


//initial function to get data
export const fetchAverageTimeToCompleteData = (userToken) => async dispatch => {
    //start loading spinner
    dispatch({ type: 'ATTA_GRAPH_IS_LOADING' });

    //API Call to get Averages Data
    let avgsData = await getDataCall(userToken);

    avgsData = await cleanUpData(avgsData);

    console.log("Avgs data cleaned: ", avgsData);



    //get all data & store in state
    // yearCountFinal: result,
    //     dailyCountFinal: dailyCounts


    dispatch({ type: 'FETCH_ATTA_DATA', payload: avgsData });
    dispatch({ type: 'ATTA_GRAPH_IS_READY' });
};

//remove any 0's , remove apps to not show like ISU
const cleanUpData = async (avgsData) => {

    avgsData.approvalTimes1Day = avgsData.approvalTimes1Day.filter(obj => obj.totalAverageTimeToApprove !== 0 && obj.appName !== "ISU");
    //console.log("TEST CLEAN AVGS: ", avgsData.approvalTimes1Day);

    avgsData.approvalTimes30Days = avgsData.approvalTimes30Days.filter(obj => obj.totalAverageTimeToApprove !== 0 && obj.appName !== 'ISU');
    // avgsData = avgsData.approvalTimes30Days.filter(obj => obj.appName !== 'ISU');

    avgsData.approvalTimes180Days = avgsData.approvalTimes180Days.filter(obj => obj.totalAverageTimeToApprove !== 0 && obj.appName !== 'ISU');
    //avgsData = avgsData.approvalTimes180Days.filter(obj => obj.appName !== 'ISU');

    return avgsData;
}


//API Call to get averages
const getDataCall = async (curToken) => {
    try {

        // Define the base URL and endpoint

        const baseUrl = process.env.REACT_APP_BASE_URL + "/Analytics/AppsAvgTimeToApprove";

        // Define headers
        const headers = {
            'Authorization': 'Bearer ' + curToken.accessToken,
        };

        // Define query parameters
        const params = {
            analyticsType: 'AppClickCount',
            platform: 'desktop'
        };

        // Make GET request 
        const response = await axios.get(baseUrl, {
            headers: headers,
            params: params
        });

        console.log("Average Approvals API Response:", response.data);
        return response.data;
        //dispatch({ type: 'ANALYTICS_ACCESS', payload: dataObj.analyticsAccess });
    } catch (error) {
        // Handle any errors
        console.log("Error getting Average Approvals  from API:");
        return [];
    }
}
